module.exports = __webpack_public_path__ + "static/img/QRcode-www2.946726c6.png";